<template>
    <div class="post post-facebook" :class="{'response-comment' : responseComment}">
        <div class="detail-event-header" :class="{'no-border' :  (post && Object.keys(post).length && !post.message) || isLoading}">
            <AvatarComponent :typeNetwork="currentPage.network" :urlPicture="currentPage.avatar" v-if="currentPage"></AvatarComponent>
            
            <div class="info">
                <div class="namePage" @click="scrollToOriginalComment" v-if="currentPage">
                    {{currentPage.name}}
                </div>
                <div class="typeEvent">
                    <p html>{{ dateFormatPost(event.date*1000) }}</p>
                    <template v-if="event.data && event.data.changes && event.data.changes.value">
                        <p  v-if="event.data.changes.value.post && event.data.changes.value.post.permalink_url" class="show-post"><a :href="event.data.changes.value.post.permalink_url" target="_blank">Voir</a></p>
                        <p  v-else-if="event.data.changes.value.link" class="show-post"><a :href="event.data.changes.value.link" target="_blank">Voir</a></p>
                        <p  v-else-if="event.data.changes.value.comment_id || event.data.changes.value.post_id" class="show-post"><a :href="`https://www.facebook.com/${event.data.changes.value.comment_id || event.data.changes.value.post_id}`" target="_blank">Voir</a></p>
                    </template>
                </div>
            </div>

          
            <div class="selectActionEvent">
                <SelectComponent :id="event._id" :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"/>
            </div>
        </div>
        <div class="scrollable">
            <template v-if="post == false" >
                <div class="container-none-post">
                  <div class="none-post">
                    <p>Post non disponible</p>
                  </div>
                </div>
            </template>
            <template v-else-if="isLoading || !post || !Object.keys(post).length">
                <div class="container-content-post loading-content">
                    <div class="content-post">
                        <div class="content">                        
                           
                            <div class="picture">
                                <!-- <img :src="attachments.media.image.src"> -->
                            </div>
                        </div>
                        <div class="bar-action-container">
                            <div class="btns-action">
                                <div class="reaction">
                                    <i class="fa-regular fa-thumbs-up"></i>
                                    réaction
                                </div>
                                <div class="comments">
                                    <i class="fa-regular fa-comment"></i>
                                    commentaire
                                </div>
                                <div class="share">
                                    <i class="fa-regular fa-share"></i>
                                    partages
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div class="container-content-comments loading-content">

                        <div class="container-comment" v-for="index in 3" :key="index">                     
                            <div class="comment">                 
                                <div class="picture-user">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC">             
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <p class="name-user">www</p>
                                        <p class="text">{{ 'w'.repeat(5+Math.random()*10) }}</p>
                                    </div>
                                    <div class="info-content">
                                        <!-- <div class="date">wwwwwwwww</div> -->
                                        <div class="action">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                </div>
            </template>
            <template v-else-if="post && Object.keys(post).length">
                <div class="container-content-post">
                    <div class="content-post">
                        <div class="content">
                        
                            <div class="story"></div>
                            <div class="text" v-if="post.message"><pre v-html="messagePostFormat(post.message)"></pre></div>

                            <a class="link" v-if="post.attachments && post.attachments.data && post.attachments.data.length && post.attachments.data[0].type == 'share' && post.attachments.data[0].target.url" :href="getLastUrlInText(decodeURIComponent(post.attachments.data[0].url)) || getLastUrlInText(post.message) || post.attachments.data[0].url" target="_blank">
                                <div class="banner-link" v-if="post.full_picture" >
                                    <img :src="post.full_picture">
                                </div>
                                <div class="footer-link">
                                    <p class="footer-link-domaine">
                                        {{ getHostname(getLastUrlInText(decodeURIComponent(post.attachments.data[0].url)) || getLastUrlInText(post.message) || post.attachments.data[0].url)}}
                                    </p>
                                    <p class="footer-link-title">
                                        {{ post.attachments.data[0].title}}
                                    </p>
                                    <p class="footer-link-description">
                                        {{ post.attachments.data[0].description }}
                                    </p>
                                </div>
                            </a>

                            <template v-if="post.attachments && post.attachments.data && post.attachments.data.length">
                                <template v-for="(attachments,indexAttachments) in post.attachments.data">
                                    <!-- media unique -->
                                    <template v-if="!attachments.subattachments">
                                        <div v-if="['photo', 'cover_photo'].includes(attachments.type)" class="picture" :key="'attachments'+indexAttachments">
                                            <img :src="attachments.media.image.src">
                                        </div>
                                        <div v-else-if="attachments.type == 'video_inline'" class="video" :key="'attachments'+indexAttachments">
                                            <video controls src="attachments.media.source" />
                     
                                        </div>
                                    </template>
                                    <!-- media multiple -->
                                    <template v-else>
                                        <div class="multi-media" :key="'attachments'+indexAttachments">
                                            <carousel :perPage="1" :adjustableHeight="true" :centerMode="true">
                                                <Slide v-for="(subattachments, index) in attachments.subattachments.data" :key="'swiper'+index">
                                                    <img v-if="['photo', 'cover_photo'].includes(subattachments.type)" :src="subattachments.media.image.src">
                                                </Slide>
                                            </carousel>
                                        </div>
                                    </template>       
                                </template>
                            </template>
                        </div>
                        <div class="bar-action-container">
                            <div class="btns-action">
                                <div class="reaction" @click="toggleLikePost(post.id)" :class="{'have-liked' : post.likes && post.likes.summary && post.likes.summary.has_liked}">
                                    <i class="fa-regular fa-thumbs-up"></i>
                                    {{ getFormatNumber(post.likes.summary.total_count) || 0 }} réaction{{post.likes.summary.total_count > 1 ? 's' : ''}}
                                </div>
                                <div class="comments" @click="autoFocus = true">
                                    <i class="fa-regular fa-comment"></i>
                                    {{ getFormatNumber(post.comments.summary.total_count) || 0 }} commentaire{{post.comments.summary.total_count > 1 ? 's' : ''}}
                                </div>
                                <div class="share" @click="!shared ? reshare() : null" :class="[{shared}]">
                                    <i class="fa-regular fa-share"></i>
                                    {{ post.shares && post.shares.count ? getFormatNumber(post.shares.count) : 0 }} partage{{post.shares && post.shares.count && post.shares.count > 1 ? 's' : ''}}
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div class="container-content-comments" ref="comments">
                    <template v-if="post.comments && post.comments.data && post.comments.data.length">
                        <div class="container-comment" v-for="(comment,indexComment) in post.comments.data" :key="comment.id" v-if="indexComment == 0 || idParentOriginalComment !== comment.id">
                            
                            <div class="comment" :class="{'has-response' : (comment.comments && comment.comments.data && comment.comments.data.length) || (comment.comment_count && comment.comment_count > 0), 'hidden':comment.is_hidden,'originalComment' : comment.originalComment}" :ref="comment.originalComment ? 'originalComment' : null">
                                <div class="picture-user">
                                    <img :src="comment.from && [comment.from.id] in saveUrlPictureUser && saveUrlPictureUser[comment.from.id] ? saveUrlPictureUser[comment.from.id] : 'img/avatar.jpg'">
                                    <div class="lineStart"></div>
                                    
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <p class="name-user">{{ comment.from ? comment.from.name : '' }}</p>
                                        <p class="text">{{ comment.message }}</p>
                                        <div class="media"></div>

                                        <ContextMenu :options="getOptionComment(comment.id, comment) " :id="comment.id" v-on:clickOption="clickOptionComment">
                                            <div class="btn-more"></div>
                                        </ContextMenu>
                                        
                                    </div>
                                    <div class="info-content">
                                        <div class="date">{{ dateFormat(comment.created_time) }}</div>
                                        <div class="action">
                                            <div class="reaction" :class="{'have-liked' : comment.user_likes}" @click="toggleLikeComment(comment.id)">J'aime {{ comment.like_count ? ` (${comment.like_count})` : ''}}</div>
                                            <div class="answer" @click="startResponseComment(comment.id)">Répondre</div>
                                            <div class="private-message" v-if="comment.from && comment.from.id !== page.network_id && comment.can_reply_privately !== false" @click="startPrivateMessage(comment.id, comment.from.name)">Message privé</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="comment.comments && comment.comments.data && comment.comments.data.length" >
                                <div v-for="(subComment,indexSubComment) in comment.comments.data" v-if="indexSubComment == 0 || subComment.id !== event.data.changes.value.comment_id" :key="subComment.id" :class="{'end': comment.comment_count == indexSubComment+1 || (!comment.comments.data[indexSubComment+1] && !comment.comments.paging.next),'hidden':subComment.is_hidden,'originalComment' : subComment.originalComment}" class="comment response" :ref="subComment.originalComment ? 'originalComment' : null">
                                    <div class="jonction-line line-continuous"></div>
                                    <div class="picture-user"> 
                                        <img :src="[subComment.from.id] in saveUrlPictureUser && saveUrlPictureUser[subComment.from.id] ? saveUrlPictureUser[subComment.from.id] : 'img/avatar.jpg'">
                                    </div>
                                    <div class="container-content">
                                        <div class="content">
                                            <p class="name-user">{{ subComment.from.name }}</p>
                                            <p class="text">{{ subComment.message }}</p>
                                            <div class="media"></div>

                                            <ContextMenu :options="getOptionComment(subComment.id, subComment) " :id="subComment.id" v-on:clickOption="clickOptionComment">
                                                <div class="btn-more"></div>
                                            </ContextMenu>
                                        </div>
                                        <div class="info-content">
                                            <div class="date">{{ dateFormat(subComment.created_time) }}</div>
                                            <div class="action">
                                                <div class="reaction" :class="{'have-liked' : subComment.user_likes}" @click="toggleLikeComment(subComment.id)">J'aime</div>
                                                <div class="answer" @click="startResponseComment(comment.id+','+subComment.id)">Répondre</div>
                                                <div class="private-message" v-if="subComment.from.id !== page.network_id && subComment.can_reply_privately !== false" @click="startPrivateMessage(subComment.id, subComment.from.name)">Message privé</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="comment.comments && comment.comments.paging && comment.comments.paging.next">     
                                    <div class="comment response end">
                                        <div class="jonction-line line-continuous"></div>
                                        <div class="container-content">
                                            <span class="more-comment"><p @click="getNextResponseComment(indexComment)">Voir plus réponses</p><div v-if="comment.displayloaderNextComment" class="util-loader"></div></span>
                                        </div>
                                    </div>
                            </template>
                        </div>
                        <span v-if="post.comments.paging && post.comments.paging.next" class="more-comment" @click="getNextComment"><p>Voir plus de commentaires</p><div v-if="displayloaderNextComment" class="util-loader"></div></span>
                    </template>
                    <template v-else>
                        <p class="no-comment">Aucun commentaire</p>
                    </template>
                </div>
            </template>
         
        </div>
       
        <FormSendMessage v-on:onSubmitMessage="sendComment" :activeMedia="false" :setAutofocus="autoFocus" @autoFocused="autoFocus = false"></FormSendMessage>

        <div class="container-response-comment" v-if="responseComment">
            <p>Répondre à <span>{{getCommentById(responseComment.split(',').pop()) ? getCommentById(responseComment.split(',').pop()).from.name : ''}}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopResponseComment"></i>
        </div>
        <div class="container-response-comment container-private-message" v-if="privateMessageComment">
            <p>Message privé à <span>{{ privateMessageComment.name }}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopPrivateMessage"></i>
        </div>
    </div>
</template>

<script>
    import mixinModeration from './../../mixins/Moderation.vue'
    import ContextMenu from './../contextMenu/contextMenuInit.vue'
    import FormSendMessage from './FormSendMessage'
    import AvatarComponent from './../utils/avatar.vue'
    import SelectComponent from './../utils/select.vue'
    import Queuer from '../../../utils/Queuer'
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'component-post-facebook',

        components: {
            FormSendMessage,
            ContextMenu,
            AvatarComponent,
            SelectComponent,
            Carousel,
            Slide
        },

        mixins: [mixinModeration],

        props: {
            page: Object,
            post: Object,
            event: Object,
            isLoading : {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                responseComment: false,
                privateMessageComment: false,
                saveUrlPictureUser : {},
                displayloaderNextComment : false,
                idParentOriginalComment : null,
                activeScrollToOriginalComment : true,
                currentPage: null,
                autoFocus: false,
                shared: false

            }
        },

        mounted () {
            this.getDetailAllComment()
            if (this.activeScrollToOriginalComment) {
                this.activeScrollToOriginalComment = false
                this.scrollToOriginalComment();
            }
        },

        updated() {
            if (this.activeScrollToOriginalComment) {
                this.activeScrollToOriginalComment = false
                this.scrollToOriginalComment();
            }
               
        },
        methods: {
             reshare() {

                let bots = JSON.parse(localStorage.bots)
                let bot = bots.find(b => b.page.id == this.page.id)

                if(!bot) {
                    console.log('no bot found')
                    return false
                }

                let body = {
                    bot: bot.id,
                    service: bot.service,
                    data: {
                        title: '',
                        url: '',
                        scheduled_date: null,
                        typePost: 'standard',
                        is_reshare: true,
                        reshare_message: '',
                        news_title: this.post.message,
                        news_url: '',
                        reshare_post_id: this.post.id
                    },
                    last: true,
                    nbPosts: 1,
                    scheduled: false
                }

                this.newPost(body).then(res => {
                    console.log('res',res)
                    const { success, error } = res.body

                    if(!success && error){
                        console.log('error reshare', error)
                    }

                    this.shared = true
                })
            },

            changeStatus(status){
                this.$emit('changeStatus', status)
            },

            // Un commentaire supprimé peut être le sujet de son propre event dans l'inbox
            // (une autre notification, indépendante de celle affichée ici) : si on le trouve,
            // on le marque supprimé aussi plutôt que de le laisser trainer en attente.
            async markCommentEventDeleted(objectId) {
                try {
                    let res = await this.getInboxEvent(this.page.id, objectId)
                    if (res && res.body && res.body.event && res.body.event._id)
                        await this.postInboxEvent(res.body.event._id, this.page, { status: 4 })
                } catch (e) {
                    console.error('markCommentEventDeleted failed', e)
                }
            },

            getFormatNumber(number) {
                const absNumber = Math.abs(number);
                const fixed = function(value){
                    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
                }

                if (absNumber >= 1e9) {
                    return fixed(number / 1e9) + ' MD';
                } else if (absNumber >= 1e6) {
                    return fixed(number / 1e6) + ' M';
                } else if (absNumber >= 1e3) {
                    return fixed(number / 1e3) + ' K';
                } else {
                    return number.toString();
                }
                
            },

            dateFormat(dateComment) {
                if (typeof dateComment !== "object") {
                    dateComment = new Date(dateComment)
                }

                let date = new Date()
                const diffInMilliseconds = Math.abs(date - dateComment);
                const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
                const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
                const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
                const diffInWeeks = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 7));
                const diffInYears = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 365));

                if (diffInYears > 0) {
                    return diffInYears + (diffInYears === 1 ? ' an' : ' ans');
                } else if (diffInWeeks > 0) {
                    return diffInWeeks + 'sem';
                } else if (diffInDays > 0) {
                    return diffInDays + 'j';
                } else if (diffInHours > 0) {
                    return diffInHours + 'h';
                } else {
                    return diffInMinutes + 'min';
                }
            },

            messagePostFormat(text) {
                // Ajouter un espace devant les https/http si aucun espace n'est présent juste avant
                // Ajouter un espace devant les www si aucun // ou espace n'est présent juste avant
                text = text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2") // eslint-disable-line

           
           

                var replacedText, replacePattern1, replacePattern2, replacePattern3;
                //URLs starting with http://, https://, or ftp://
                replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim; // eslint-disable-line
                replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

                //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
                replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim; // eslint-disable-line
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

                //Change email addresses to mailto:: links.
                replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim; // eslint-disable-line
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>'); // eslint-disable-line

                return replacedText.trim();
            },

            getLastUrlInText(text) {
                try {
                    return text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2").match(/\b(?:https?:\/\/(?:www\.)?|www\.)\S+/gi).slice(-1)[0] // eslint-disable-line
                }catch (error) {
                    return false
                }
                
            },

            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },

            dateFormatPost(dateMessage) {
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            have_liked_comment(nodeId){

                try {
                    this.post.comment.likes.data.find(liker => liker.id == this.page.network_id) 
                } catch (error) {
                    return false
                }   
            },

            startResponseComment(commentId) {
                this.responseComment = commentId;
                this.privateMessageComment = false;
            },
           
            scrollToOriginalComment() {
                if(this.$refs.originalComment && this.$refs.originalComment.length) {
                    const element = this.$refs.originalComment[0];
                    if (element) {
                        this.$refs.comments.scrollIntoView({ behavior: "smooth"});
                    }
                }
            },

            stopResponseComment() {
                this.responseComment = false
            },

            startPrivateMessage(commentId, name) {
                this.privateMessageComment = { id: commentId, name }
                this.responseComment = false
                this.autoFocus = true
            },

            stopPrivateMessage() {
                this.privateMessageComment = false
            },

            getCommentById(commentId,returnNode = false) {
                if (this.post.comments && this.post.comments.data) {
                    for (const comment of this.post.comments.data) {
                        if (comment.id == commentId) {
                            return returnNode ? this.post.comments : comment;
                        } else if (comment.comments && comment.comments.data) {
                            for (const subComment of comment.comments.data) {
                                if (subComment.id == commentId) {
                                    return returnNode ? comment.comments : subComment;
                                }else if (subComment.comments && subComment.comments.data) {
                                    for (const subsubComment of subComment.comments.data) {
                                        if (subsubComment.id == commentId) {
                                            return returnNode ? subComment.comments : subsubComment;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            },
            
            async toggleLikeComment(nodeId) {
                let comment = this.getCommentById(nodeId) 
                console.log(comment)
                if (comment.user_likes) return

                const toggleFlagLike = async (comment)=>{
                    if (!comment.user_likes) {
                        await this.$set(comment,'user_likes',true)
                        await this.$set(comment, 'like_count', comment.like_count ? comment.like_count + 1 : 1)
                    }
                    //comment.user_likes = comment.user_likes ? !comment.user_likes : true
                    return comment.user_likes 
                }

                const flagLike = await toggleFlagLike(comment)
                if (flagLike !== undefined) {
                    let res = await this.likeNode(this.page, nodeId)
       
                    const { success, error } = res.body
                 
                    if (!success || success !== true) {
                        toggleFlagLike(comment)
                        return false
                    }

                    return true
                    
                }
            },

            async toggleLikePost(nodeId) {

                const wasLiked = this.post.likes.summary.has_liked
                const previousCount = this.post.likes.summary.total_count

                this.$set(this.post.likes.summary, 'has_liked', !wasLiked)
                this.$set(this.post.likes.summary, 'total_count', (previousCount || 0) + (wasLiked ? -1 : 1))

                let res = await this.likeNode(this.page, nodeId, null, wasLiked)

                const { success, error } = res.body

                if (!success || success !== true) {
                    this.$set(this.post.likes.summary, 'has_liked', wasLiked)
                    this.$set(this.post.likes.summary, 'total_count', previousCount)
                    return false
                }

                this.$emit('updateEventMissingInfos', this.event._id, this.page)

                return true

            },
    
            async sendComment(formData,filesUrl = []) {

                if (this.post && formData.get('message')) {

                    if (this.privateMessageComment) {
                        const res = await this.sendPrivateReply(this.page, this.privateMessageComment.id, formData.get('message'))
                        if (!res.body || !res.body.success) {
                            const errorKey = res.body && res.body.error
                            const knownKeys = [
                                'dash.error.private-reply-admin-permission',
                                'dash.error.private-reply-comment-not-found',
                                'dash.error.private-reply-disabled',
                                'dash.error.send-private-message-failed'
                            ]
                            this.$vs.notify({
                                title: this.$t('onboarding.2fa.error_title'),
                                text: knownKeys.includes(errorKey)
                                    ? this.$t(errorKey)
                                    : this.$t('dash.error.send-private-message-failed-generic'),
                                color: 'danger',
                                time: 10000
                            })
                            return
                        }
                        this.$vs.notify({
                            title: this.$t('dash.moderation.private-reply-success-title'),
                            text: this.$t('dash.moderation.private-reply-success-text'),
                            color: 'success',
                            time: 5000
                        })
                        this.stopPrivateMessage()
                        return
                    }

                    if (this.responseComment) {
                        console.log(this.responseComment,this.responseComment.split(',')[0])
                        const commentTarget = this.getCommentById(this.responseComment.split(',')[0])
                        console.log("commentTarget",commentTarget)
                        if (commentTarget) {
                            
                            if (!commentTarget.comments || !commentTarget.comments.data) {
                      
                                await this.$set(commentTarget,'comments' ,{
                                    data : [

                                    ],
                                    paging : {
                                        "cursors":{
                                            "before":"",
                                            "after":""}
                                    },
                                    summary : {
                                        "order":"ranked",
                                        "total_count":0,
                                        "can_comment":true
                                    }
                                })
                                commentTarget.comment_count = 0
                            }

                            commentTarget.comment_count++

                            await this.$set(commentTarget.comments.data, commentTarget.comments.data.length, {
                                can_hide: false,
                                comment_count: 0,
                                created_time: new Date().toISOString(),
                                from: {"name":this.page.name, email:"", id: this.page.network_id},
                                id: "",
                                is_hidden: false,
                                like_count: 0,
                                message: formData.get('message'),
                                user_likes: false,
                                user : {
                                    "name":this.page.name,
                                    "picture":{
                                        "data":{
                                            "is_silhouette":false,
                                            "url":this.page.avatar,
                                        }
                                    }
                                }
                            });
                            
                            let res = await this.addComment(this.page, commentTarget.id, formData.get('message'))
                            const { success, comment } = res.body

                            if (!success || success !== true) {
                                commentTarget.comments.data.pop()
                                return
                            }
                                
                        }
                                        
                        this.stopResponseComment()
                    }else{
                        if (!this.post.comments || !this.post.comments.data) {
                            await this.$set(this.post,'comments' ,{
                                data : [
                                    
                                ],
                                summary : {
                                    "order":"ranked",
                                    "total_count":0,
                                    "can_comment":true
                                }
                            })
                        }
                        
                        await this.$set(this.post.comments.data, this.post.comments.data.length, {
                            can_hide: false,
                            comment_count: 0,
                            created_time: new Date().toISOString(),
                            from: {"name":this.page.name, email:"", id:this.page.network_id},
                            id: "",
                            is_hidden: false,
                            like_count: 0,
                            message: formData.get('message'),
                            user_likes: false,
                            user : {
                                    "name":this.page.name,
                                    "picture":{
                                        "data":{
                                            "is_silhouette":false,
                                            "url":this.page.avatar,
                                        }
                                    }
                                }
                        })

                        let res = await this.addComment(this.page, this.post.id, formData.get('message'))
                        const { success, comment } = res.body

                        if (!success || success !== true) {
                            this.post.comments.data.pop()
                            return
                        } 
                    }    
                    
                }

            },

            async clickOptionComment(id, nameOption) {
      
            
                switch (nameOption) {
                    case 'deleteComment': {
                        //save parent
                        let isOriginalComment = id == this.idParentOriginalComment
                        let nodeComment = this.getCommentById(id,true)

                        if (nodeComment) {
                            let saveNodeComment = Object.assign({}, nodeComment);
                            nodeComment.data = nodeComment.data.filter((comment) => comment.id !== id)

                            let res = await this.deleteNode(this.page, id)
                            let { success, error } = res.body;

                            if (!success || success !== true) {
                                nodeComment = saveNodeComment
                            }
                            else if (isOriginalComment) {
                                this.$emit('deleteComment', this.event._id)
                            }
                            else {
                                this.markCommentEventDeleted(id)
                            }
                        }

                        break;
                    }
                        
                    case 'hideComment': {
                        let commentHide = this.getCommentById(id)
                        commentHide.is_hidden = false
                        let resHideComment = await this.hideNode(this.page, this.event.object_id, true)  //true, incoherence du server (ça devrait etre true) 
                        let { success: hideSuccess, error: hideError } = resHideComment.body;
                      
                        if (!hideSuccess || hideSuccess !== true) {
                            commentHide.is_hidden = false
                        }
                        break;
                    }

                    case 'showComment': {
                        let commentShow = this.getCommentById(id)
                        commentShow.is_hidden = true
                
                        let resShowComment = await this.hideNode(this.page, this.event.object_id, false) //false, incoherence du server (ça devrait etre false) 
                        let { success: showSuccess, error: showError } = resShowComment.body;
              
                        if (!showSuccess || showSuccess !== true) {
                            commentShow.is_hidden = false
                        }
                        break;
                    }

                    case 'evaluateComment': {
                    
                        break;
                    }
              
                }
            },
     
            getOptionComment(idComment, comment) {
                if (!comment) {
                    comment = this.getCommentById(idComment)
                }

                let options = [{label: this.$t('dash.button.delete'), name : 'deleteComment'}]
                //,{label: this.$t('dash.inbox.filter.evaluate'), name : 'evaluateComment'}

                if (comment.can_hide && comment.from.id !== this.page.network_id) {

                    if (comment.is_hidden) {
                        options = [{label: this.$t('dash.inbox.state.unhide'), name : 'showComment'},...options]
                    }else{
                        options = [{label: this.$t('dash.pages.group.hide'), name : 'hideComment'},...options]
                    }
      
                }
                return options



            },

            async getOriginalComment() {
                if (this.post && this.post.comments && this.post.comments.data) {
                    this.idParentOriginalComment = this.event.data.changes.value.parent_id == this.event.data.changes.value.post_id ? (this.event.data.changes.value.comment_id || this.event.data.changes.value.id) : (this.event.data.changes.value.parent_id || this.event.data.changes.value.comment_id)
                    let res = await this.getCommentPost(this.page, this.event.data.changes.value.post_id, this.idParentOriginalComment)
                    // this.post can be swapped/cleared while the request above is in flight
                    if (!this.post || !this.post.comments || !this.post.comments.data) return
                    const { success, error, comment } = res.body
                    if (success && comment ) {
                        const existingInList = this.post.comments.data.find(c => c.id === comment.id)
                        this.post.comments.data = [{
                            ...(existingInList && existingInList.can_reply_privately !== undefined ? { can_reply_privately: existingInList.can_reply_privately } : {}),
                            ...comment,
                            originalComment : this.event.data.changes.value.parent_id === this.event.data.changes.value.post_id,
                        }, ...this.post.comments.data.filter(c => c.id !== comment.id)]

                        //si origine comment est une reponse
                        if (this.event.data.changes.value.parent_id !== this.event.data.changes.value.post_id && this.post.comments.data[0].comments) {
                            this.post.comments.data[0].comments.data = [
                                {
                                    ...this.event.data.changes.value,
                                    id : this.event.data.changes.value.comment_id,
                                    created_time : this.event.data.changes.value.created_time*1000,
                                    originalComment : true
                                },
                                ...(this.post.comments.data[0].comments.data.filter(c=> c.id !== this.event.data.changes.value.comment_id))
                            ]
                        }
                    }
                }
            },

            async getDetailAllComment(indexStart = 0, indexEnd = null) {
                if (this.post && this.post.comments &&  this.post.comments.data) {
                    if(!indexEnd)
                        indexEnd = this.post.comments.data.length
                  
                    let queueComment = new Queuer({
                        data: JSON.parse(JSON.stringify(this.post.comments.data)).slice(indexStart,indexEnd),
                        task: async (comment) => {
                            
                            let ind = this.post.comments.data.findIndex(c => c.id == comment.id)
                            if (ind === -1) return

                            //verifier si le liens de l'image existe déja pour eviter une requette
                            if (comment.from && !([comment.from.id] in this.saveUrlPictureUser)) {
                                let resComment = await this.getEventMissingInfosFromRS(this.page.id, comment.from.id, 'comment')
                                if(resComment && resComment.body && resComment.body.user) {
                                    this.$set(this.post.comments.data[ind], 'user', resComment.body.user)
                                    this.saveUrlPictureUser[comment.from.id] = (resComment.body.user.picture && resComment.body.user.picture.data && !resComment.body.user.picture.data.is_silhouette && resComment.body.user.picture.data.url) ? resComment.body.user.picture.data.url : false               
                                }
                            }
                            if (this.post.comments.data[ind] && this.post.comments.data[ind].comments && this.post.comments.data[ind].comments.data && this.post.comments.data[ind].comments.data.length) {

                                let queueSubComment = new Queuer({
                            
                                    data: JSON.parse(JSON.stringify(this.post.comments.data[ind].comments.data)),
                                    task: async (subComment) => {
                                        let iSubComment = this.post.comments.data[ind].comments.data.findIndex(c => c.id == subComment.id)
                                       
                                        //verifier si le liens de l'image existe déja pour eviter une requette
                                        if (!([subComment.from.id] in this.saveUrlPictureUser)) {
                                            let resComment = await this.getEventMissingInfosFromRS(this.page.id, subComment.from.id, 'comment')
                                            if(resComment && resComment.body && resComment.body.user) {
                                                this.$set(this.post.comments.data[ind].comments.data[iSubComment], 'user', resComment.body.user)
                                                this.saveUrlPictureUser[subComment.from.id] = (resComment.body.user.picture && resComment.body.user.picture.data && !resComment.body.user.picture.data.is_silhouette && resComment.body.user.picture.data.url) ? resComment.body.user.picture.data.url : false
                                            }
                                        }
                                        queueSubComment.unlock()
                                    }
                                })
                                setTimeout(queueSubComment.init(), 500)
                            }
                            queueComment.unlock()         
                        }
                    })
                    setTimeout(queueComment.init(), 500)
                }
            },

            async getNextComment() {
     
                if (this.post.comments.paging.next) {
                    this.displayloaderNextComment = true
                    let request = await this.$http.get(this.post.comments.paging.next, {}).then(res => res, err => err);
                  
                    if (request.body && request.body.data) {
                        if (request.body.paging) {
                            this.post.comments.paging = request.body.paging
                        }else{
                            this.post.comments.paging = false
                        }
                        let newArray = (this.post.comments.data).concat(request.body.data)
                        this.post.comments.data = newArray
                        this.getDetailAllComment(newArray.length-request.body.data.length-1)
                    }
                   
                    this.displayloaderNextComment = false
                }
            },

            async getNextResponseComment(indexComment) {
            
                if (this.post.comments && this.post.comments.data && this.post.comments.data[indexComment]  && this.post.comments.data[indexComment].comments && this.post.comments.data[indexComment].comments.paging && this.post.comments.data[indexComment].comments.paging.next) {
                    
                    this.$set(this.post.comments.data[indexComment], 'displayloaderNextComment', true)
                    let request = await this.$http.get(this.post.comments.data[indexComment].comments.paging.next, {}).then(res => res, err => err);
                  
                    if (request.body && request.body.data) {
                        if (request.body.paging) this.post.comments.data[indexComment].comments.paging = request.body.paging

                        if (this.idParentOriginalComment == this.post.comments.data[indexComment].id) {
                            request.body.data = request.body.data.filter(c=> c.id !== this.event.data.changes.value.comment_id) //retire le commentaire de l'evenement car deja inserer
                        }

                        let newArray = (this.post.comments.data[indexComment].comments.data).concat(request.body.data)
                        this.post.comments.data[indexComment].comments.data = newArray
                        this.getDetailAllComment(indexComment,indexComment+1)
                    }
                    this.post.comments.data[indexComment].displayloaderNextComment = false
                }
            },

        },

        watch: {
            async post(newPost, lastPost) {
                if (this.post && Object.keys(this.post).length) {
                    // this.isLoading = true
                    await this.getOriginalComment()
                    await this.getDetailAllComment()
                    if (!lastPost || newPost.id !== lastPost.id) {
                        this.activeScrollToOriginalComment = true
                    }
                    // this.isLoading = false
                } 
                
                this.currentPage = this.page
                if(this.event.type == 'mention') {
                    this.getEventMissingInfosFromRS(this.page.id, this.event.data.changes.value.post_id.split('_')[0], 'mention').then((res) => {
                        if(res && res.body && res.body.user) {
                            this.currentPage = {
                                avatar: res.body.user.picture ? res.body.user.picture.data.url : null,
                                name: res.body.user.name,
                                network: 'facebook',
                                network_id: res.body.user.id
                            }
                        }
                    })
                }
               
            }
        },
    }
</script>
